import { translate } from '../../../Internationalization';
import React from 'react';
import useTheme from '../../../../Hooks/Shared/useTheme/useTheme';

const occupationPath = 'homeowner.pages.dashboard.agent.occupation';

export default function AgentCardHeader() {
	const { agentOccupation, teamList } = useTheme();
	const { cobranding } = teamList.find(({primaryGroup}) => primaryGroup)?.primaryGroup ?? {}; //	prettier-ignore
	const teamCta = cobranding ? 'contact_team' : `${agentOccupation}`;

	return (
		<header className="card-header">
			<h3 className="card-title">
				{translate(
					`${occupationPath}.contact`,
					translate(`${occupationPath}.${teamCta}`)
				)}
			</h3>
		</header>
	);
}
